import {
    CREATE_VIDEO_GUIDE_SUCCESS,
    CREATE_VIDEO_GUIDE_ERROR,
    CREATE_VIDEO_GUIDE_REQUEST,
    DELETE_VIDEO_GUIDE_SUCCESS,
    DELETE_VIDEO_GUIDE_ERROR,
    DELETE_VIDEO_GUIDE_REQUEST,
    LIST_VIDEO_GUIDE_SUCCESS,
    LIST_VIDEO_GUIDE_ERROR,
    LIST_VIDEO_GUIDE_REQUEST,
    EDIT_VIDEO_GUIDE_SUCCESS,
    EDIT_VIDEO_GUIDE_ERROR,
    EDIT_VIDEO_GUIDE_REQUEST,


    LIST_EDIT_VIDEO_GUIDE_SUCCESS,
    LIST_EDIT_VIDEO_GUIDE_ERROR,
    LIST_EDIT_VIDEO_GUIDE_REQUEST,
  } from "../../Types/user/Types";


  const initialState = {
    error: "",
    create_video_guide_data: "",
    loader: false,
  };
  const initialStateList={
      error:"",
      list_video_guide_data:"",
      list_edit_video_guide_data:"",

      loader:false
  }
  const initialStateDelete={
      error:'',
      delete_video_guide_data:'',
      loader:false
  }
  const initialStateEdit={
      error:'',
      edit_video_guide_data:'',
      loader:false
  }

   export const create_Video_Guide_Reducer = (state = initialState, action) => {
    switch (action.type) {
      case CREATE_VIDEO_GUIDE_SUCCESS:
        return {
          ...initialState.create_video_guide_data,
          error: "",
          create_video_guide_data: action.payload,
          loader: false,
        };
      case CREATE_VIDEO_GUIDE_ERROR:
        return {
          ...initialState.create_video_guide_data,
          error: action.error,
          create_video_guide_data: "",
          loader: false,
        };
      case  CREATE_VIDEO_GUIDE_REQUEST:
        return {
          ...initialState.create_video_guide_data,
          error: null,
          create_video_guide_data: "",
          loader: true,
        };
      default:
        return state;
    }
  };
  export const list_Video_Guide_Reducer = (state = initialStateList, action) => {
    switch (action.type) {
      case LIST_VIDEO_GUIDE_SUCCESS:
        return {
          ...initialStateList.list_video_guide_data,
          error: "",
          list_video_guide_data: action.payload,
          loader: false,
        };
      case LIST_VIDEO_GUIDE_ERROR:
        return {
          ...initialStateList.list_video_guide_data,
          error: action.error,
          list_video_guide_data: "",
          loader: false,
        };
      case LIST_VIDEO_GUIDE_REQUEST:
        return {
          ...initialStateList.list_video_guide_data,
          error: null,
          list_video_guide_data: "",
          loader: true,
        };
      default:
        return state;
    }
  };


  export const list_edit_Video_Guide_Reducer = (state = initialStateList, action) => {
    switch (action.type) {
      case LIST_EDIT_VIDEO_GUIDE_SUCCESS:
        return {
          ...initialStateList.list_edit_video_guide_data,
          error: "",
          list_edit_video_guide_data: action.payload,
          loader: false,
        };
      case LIST_EDIT_VIDEO_GUIDE_ERROR:
        return {
          ...initialStateList.list_edit_video_guide_data,
          error: action.error,
          list_edit_video_guide_data: "",
          loader: false,
        };
      case LIST_EDIT_VIDEO_GUIDE_REQUEST:
        return {
          ...initialStateList.list_edit_video_guide_data,
          error: null,
          list_edit_video_guide_data: "",
          loader: true,
        };
      default:
        return state;
    }
  };





  export const delete_Video_Guide_Reducer=(state = initialState, action) => {
    switch (action.type) {
      case DELETE_VIDEO_GUIDE_SUCCESS:
        return {
          ...initialStateDelete.delete_video_guide_data,
          error: "",
          delete_video_guide_data: action.payload,
          loader: false,
        };
      case DELETE_VIDEO_GUIDE_ERROR:
        return {
          ...initialStateDelete.delete_video_guide_data,
          error: action.error,
          delete_video_guide_data: "",
          loader: false,
        };
      case DELETE_VIDEO_GUIDE_REQUEST:
        return {
          ...initialStateDelete.delete_video_guide_data,
          error: null,
          delete_video_guide_data: "",
          loader: true,
        };
      default:
        return state;
    }
  };


  export const edit_Video_Guide_Reducer = (state = initialState, action) => {
    switch (action.type) {
      case EDIT_VIDEO_GUIDE_SUCCESS:
        return {
          ...initialStateEdit.edit_video_guide_data,
          error: "",
          edit_video_guide_data: action.payload,
          loader: false,
        };
      case EDIT_VIDEO_GUIDE_ERROR:
        return {
          ...initialStateEdit.edit_video_guide_data,
          error: action.error,
          edit_video_guide_data: "",
          loader: false,
        };
      case EDIT_VIDEO_GUIDE_REQUEST:
        return {
          ...initialStateEdit.edit_video_guide_data,
          error: null,
          edit_video_guide_data: "",
          loader: true,
        };
      default:
        return state;
    }
  };


  